export default __webpack_public_path__ + "static/media/Git_icon.b84e9605.svg";